"use client";

import React, { forwardRef, useEffect, useState } from "react";
import style from "./OurServices.module.scss";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";

interface OurServicesProps {
  messages?: any;
}

const OurServices = forwardRef<HTMLElement, OurServicesProps>(
  ({ messages }: OurServicesProps, ref) => {
    const [visibleItems, setVisibleItems] = useState([]);
    useEffect(() => {
      const handleScroll = () => {
        const itemList = document.querySelectorAll(
          "." + style.ourServiceswrap + " ul li"
        );
        const items = [];

        itemList.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const isVisible =
            rect.top >= 0 &&
            rect.bottom <=
              (window.innerHeight || document.documentElement.clientHeight);
          if (isVisible) {
            items.push(item);
          }
        });

        setVisibleItems(items);
      };

      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleScroll);
      };
    }, []);

    if (!messages.our_list || messages.our_list.length === 0) return null;

    return (
      <section
        className={`${style.ourServiceswrap} ${style.spacingNone}`}
        ref={ref}
      >
        <div className="container">
          <div
            className={messages?.description ? style.titleDescription : null}
          >
            <TitleAnimation
              messages={{
                first_word: messages?.first_word,
                second_word: messages?.second_word,
              }}
            />
            {messages?.description ? (
              <div className={style.subtitle}>
                <p>{messages.description}</p>
              </div>
            ) : null}
          </div>
          <div
            className={`${style.ourListDuck} ${messages?.description ? style.spacingNone : null}`}
          >
            <ul className={style.list}>
              {messages.our_list.map((service, index) => (
                <li
                  key={index}
                  className={
                    visibleItems &&
                    visibleItems[0] &&
                    visibleItems[0].firstChild.innerHTML.slice(-1) - 1 == index
                      ? style.visible
                      : ""
                  }
                >
                  <span>0{index + 1}</span>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    );
  }
);

export default OurServices;

OurServices.displayName = "OurServices";
